import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//components
import { DeleteDialogComponent } from '../core/dialogs/delete-dialog/delete-dialog.component';
import { NotificationMessageComponent } from '../pages/notification-message/notification-message.component';
import { EditButtonfromGridComponent } from '../core/grid/edit-buttonfrom-grid.component';
import { RefreshGridComponent } from '../core/refresh-grid/refresh-grid.component';
import { BtnCellRendererEditDelete } from '../core/grid/btn-cell-render-edit-delete';
import { AudioComponent } from '../core/audio/audio.component';

//mat
import { MatIconModule } from '@angular/material/icon';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSelectModule } from '@angular/material/select';
import { CustomCellEditorComponent } from '../pages/administration/site-configuration/route-system/custom-cell-editor.component';
import { CustomCellEditorRouteComponent } from '../pages/reports/route-pcb/custom-cell-editor-route.component';
import { DropdownCellRenderer } from '../pages/reports/route-pcb/dropdowncellRenderer';


@NgModule({
  declarations: [
    DeleteDialogComponent,
    NotificationMessageComponent,
    EditButtonfromGridComponent,
    RefreshGridComponent,
    BtnCellRendererEditDelete,
    AudioComponent,
    CustomCellEditorComponent,
    CustomCellEditorRouteComponent,
    DropdownCellRenderer
  ],
  imports: [
    MatIconModule,
    CommonModule,
    MatMomentDateModule,
    FormsModule,
    FormsModule,
    ReactiveFormsModule,
    //newly added imports
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatTabsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    // AgGridModule,
    // NgxBarcodeModule
    // MatCarouselModule
    FlexLayoutModule
  ],
  exports: [
    DeleteDialogComponent,
    NotificationMessageComponent,
    EditButtonfromGridComponent,
    RefreshGridComponent,
    BtnCellRendererEditDelete,
    MatMomentDateModule,
    CustomCellEditorComponent,
    CustomCellEditorRouteComponent,
    //newly added imports
    MatIconModule,
    // CommonModule,
    // MatMomentDateModule,
    // FormsModule,
    // FormsModule,
    // ReactiveFormsModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatTabsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    // AgGridModule,
    // NgxBarcodeModule
    //MatCarouselModule
    FlexLayoutModule,
    AudioComponent,
    MatSelectModule,
    DropdownCellRenderer
  ],
  providers: [{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }],
})
export class SharedModule { }
